export const MAX_MODAL_HEIGHT_DIFF = 55;

export const DEFAULT_OLD_COMPLETE_MODAL_PROPS = {
  avatar: null,
  username: '',
  location: '',
  age: '',
  editProfileLink: '',
};

export const MODAL_MAX_HEIGHT_VALUE = 80; // vh

export const MODAL_BODY_PADDING_VALUE = 60; // px
